import { HumanFigure } from './HumanFigure';
import './StageOrientation.css';

interface StageOrientationProps {
  onBegin: () => void;
}

export function StageOrientation({ onBegin }: StageOrientationProps) {
  return (
    <div className="stage-orientation">
      <div className="stage-orientation__backdrop" />
      <div className="stage-orientation__content">
        <div className="stage-orientation__figure">
          <HumanFigure activeLayer={null} />
        </div>
        <div className="stage-orientation__text">
          <p className="stage-orientation__statement">
            You do not experience reality directly.
          </p>
          <p className="stage-orientation__sub">
            What you perceive has already been compressed, filtered, and shaped
            before it reaches awareness.
          </p>
          <button className="stage-orientation__begin" onClick={onBegin}>
            Begin
          </button>
        </div>
      </div>
    </div>
  );
}
